import React from 'react';
import ReportingFinancesPaymentsPage from '../components/ReportingFinancesPaymentsPage';

const ReportingFinancesPaymentsApp = (props) => (
  <ReportingFinancesPaymentsPage {...props} />
);

export default ReportingFinancesPaymentsApp;
